// extracted by mini-css-extract-plugin
export default {"pageContainer":"ForeignTravellers_pageContainer__Twl0s"};